<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <h2>Codium Mission and Vision</h2>

      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="card card-widget h-100">
            <div class="card-body">
              <h3 class="widget-title">Vision</h3>
              <p class="lead mb-0">See all businesses using the right solutions to reach their full potential.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card card-widget h-100">
            <div class="card-body">
              <h3 class="widget-title">Mission</h3>
              <p class="lead mb-0">To accelerate businesses to success by using quality software as a catalyst.</p>
            </div>
          </div>
        </div>
      </div>

      <h2 class="mt-3">Core Values</h2>

      <div class="row">
        <div v-for="value in values" :key="value.name" class="col-md-6 col-xl-3 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <h3 class="card-title">
                <i class="far fa-fw me-1 text-primary" :class="value.icon"></i>
                {{ value.name }}
              </h3>
              <p class="mb-0">{{ value.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      values: [
        {
          name: 'Resilience',
          icon: 'fa-mountain',
          description: 'We strive for quality. We don’t take the easy solution, we find the right solution.'
        },
        {
          name: 'Integrity',
          icon: 'fa-balance-scale',
          description: 'We have strong moral principles and will always do the right thing by our clients and our co-workers.'
        },
        {
          name: 'Fun',
          icon: 'fa-smile',
          description: 'We come to work because of choice. We will celebrate our successes. We believe it is important to work hard and have fun while we are doing it.'
        },
        {
          name: 'Respect',
          icon: 'fa-handshake',
          description: 'We care about our clients. We treat everyone with respect, the same way we expect to be treated.'
        }
      ]
    }
  }
}
</script>
